export enum MachineFieldTypeEnums {
    MODEL = 0,
    COMMISSON_NUMBER = 1,
    SERIAL_NUMBER = 2,
    SOFTWARE_VERSION = 3,
    UNKNOWN = 999,
}
